
import { defineComponent, ref } from "vue";
import { Field, useField, Form } from "vee-validate";

export default defineComponent({
  components: {
    "v-field": Field,
    "v-form": Form,
  },
  name: "Home",
  setup() {
    const inputTest = ref("");

    const {
      value: validateValue,
      errorMessage,
      handleChange: validationTracking,
    } = useField("test", "required|between:3,10", {
      initialValue: inputTest,
    });

    return {
      inputTest,
      validationTracking,
      errorMessage,
      validateValue,
    };
  },
});
